import React from "react";
import { Route, Routes } from "react-router-dom";
import ROUTES_NAVIGATION from "./routes";
import NotificationList from "../components/DealerManagement/Admin/NotificationManagement/NotificationList";
import SetNotification from "../components/DealerManagement/Admin/NotificationManagement/SetNotification";
import UpdateNotification from "../components/DealerManagement/Admin/NotificationManagement/UpdateNotification";
import OrderManagementList from "../components/DealerManagement/Admin/OrderManagement";
import AcceptOrderDetails from "../components/DealerManagement/Admin/OrderManagement/AcceptOrderDetails/AcceptOrderDetails";


const OrderManagementRoutes = () => {
  return (
    <>
    <Route
        path={ROUTES_NAVIGATION.ORDERMANAGEMENTLIST}
        element={<OrderManagementList />}
      />
       <Route
        path={ROUTES_NAVIGATION.ACCEPTORDERDETAILS}
        element={<AcceptOrderDetails />}
      />
        <Route
        path={ROUTES_NAVIGATION.UPDATENOTIFICATION}
        element={<UpdateNotification />}
      />
    
     

    </>
  );
};

export default OrderManagementRoutes;
